import { useEffect, useState } from 'react'
import PubSub from 'pubsub-js'
import FileProgress from '../FileProgress/FileProgress'
import './Upload.css'

export default function Upload({ objectId, files }) {
  console.log(`Upload rendered: ${objectId}`, files)

  const [uploads] = useState(files)
  const [changeCount, setChangeCount] = useState(0)

  useEffect(() => {
    function handleUploadChange(msg, data) {
      console.log(`EVENT RECEIVED (Upload): ${msg}`, data)
      setChangeCount(changeCount + 1)
    }
    const uploadChangeToken = PubSub.subscribe(`UPLOAD CHANGE ${objectId}`, handleUploadChange)
    return function cleanup() {
      PubSub.unsubscribe(uploadChangeToken)
    }
  })

  const progressList = []
  for (let fileInfo in uploads) {
    progressList.push(<FileProgress key={uploads[fileInfo].file.name} className="upload-progress" fileInfo={uploads[fileInfo]} />)
  }

  if (!uploads || Object.keys(uploads).length === 0) {
    return null
  }

  return (
    <div className="upload-container">
      <span className="upload-title">Upload Files</span>
      <div className="upload-list-container">
        {progressList}
      </div>
    </div>
  )
}